export default {
  patients: {
    label: 'Pasien',
    viewPatients: 'Lihat Pasien',
    viewPatient: 'Lihat Pasien',
    editPatient: 'Ganti Pasien',
    newPatient: 'Pasien Baru',
  },
}
